import React, { FC } from 'react';
import styles from './nav_group.module.scss';

export const NavGroup: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
